module.exports = __webpack_public_path__ + "static/media/noSignalIconSemSobra.6b1ff9ac.svg";